import { z } from 'zod';
/**
 * Виды учётных данных. Совпадает с перечислением credential_kind в базе.
 * orderhub присутствует, но его состав ещё неизвестен — сервис не изучен,
 * поэтому схема намеренно свободная и будет уточнена после получения доступа.
 */
export const CREDENTIAL_KINDS = ['chatapp', 'openai', 'keitaro', 'orderhub', 'robot'];
export const credentialKindSchema = z.enum(CREDENTIAL_KINDS);
// ─── состав по видам ───
export const chatappCredentialSchema = z.object({
    email: z.string().email().max(320),
    password: z.string().min(1).max(200),
    /** appId из кабинета ChatApp. Вебхуки и токены изолированы по нему. */
    appId: z.string().min(1).max(100),
});
export const openaiCredentialSchema = z.object({
    apiKey: z.string().min(20).max(300),
    organization: z.string().max(100).optional(),
    project: z.string().max(100).optional(),
});
export const keitaroCredentialSchema = z.object({
    /** Адрес трекера без завершающего слэша. */
    trackerUrl: z.string().url().max(500),
    /**
     * Postback URL целиком, дословно скопированный из трекера
     * (Settings → Postback URL). Ключ входит в путь, поэтому собирать
     * этот адрес из частей нельзя.
     */
    postbackUrl: z.string().url().max(1000),
    /** Строка, которую передаём в &return= и по которой опознаём успех. */
    returnToken: z.string().min(1).max(50).default('OK'),
    /** Ключ Admin API — только для сверки отчётов, конверсии им не создаются. */
    adminApiKey: z.string().max(300).optional(),
});
export const orderhubCredentialSchema = z.object({
    baseUrl: z.string().url().max(500).optional(),
    token: z.string().max(500).optional(),
    note: z.string().max(1000).optional(),
});
/**
 * Робот — сервис товаров собственной разработки. Каталог у нас строится
 * из него: раз-два в сутки мы забираем список и обновляем зеркало.
 *
 * Два поля, и оба обязательны: без адреса некуда идти, без ключа не
 * пустят. Необязательными они были бы, только если бы существовал
 * второй способ подключиться, а его нет.
 */
export const robotCredentialSchema = z.object({
    baseUrl: z.string().url().max(500),
    apiKey: z.string().min(1).max(500),
    note: z.string().max(1000).optional(),
});
export const CREDENTIAL_PAYLOAD_SCHEMAS = {
    chatapp: chatappCredentialSchema,
    openai: openaiCredentialSchema,
    keitaro: keitaroCredentialSchema,
    orderhub: orderhubCredentialSchema,
    robot: robotCredentialSchema,
};
// ─── запись ───
export const upsertCredentialSchema = z.discriminatedUnion('kind', [
    z.object({
        kind: z.literal('chatapp'),
        label: z.string().min(1).max(100).default('default'),
        payload: chatappCredentialSchema,
    }),
    z.object({
        kind: z.literal('openai'),
        label: z.string().min(1).max(100).default('default'),
        payload: openaiCredentialSchema,
    }),
    z.object({
        kind: z.literal('keitaro'),
        label: z.string().min(1).max(100).default('default'),
        payload: keitaroCredentialSchema,
    }),
    z.object({
        kind: z.literal('orderhub'),
        label: z.string().min(1).max(100).default('default'),
        payload: orderhubCredentialSchema,
    }),
]);
// ─── чтение ───
/**
 * Что уходит наружу. Секретов здесь нет и быть не может:
 * только подсказки вида «ключ ···· 4f2a», по которым человек
 * узнаёт свою запись, не видя её значения.
 */
export const credentialSummarySchema = z.object({
    id: z.uuid(),
    kind: credentialKindSchema,
    label: z.string(),
    hints: z.record(z.string(), z.string()),
    verifiedAt: z.iso.datetime().nullable(),
    lastUsedAt: z.iso.datetime().nullable(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
//# sourceMappingURL=credentials.js.map